import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useFormikContext } from "formik";
import { TextButton } from "@qgiv/core-donor";
import { setAppShowRemainingForm } from "../../../../../redux/slices/appSettingsSlice";

const ParticipantSummaryRemoveButton = ({
    addAdditionalParticipantDisabled,
    currentRegistration,
    removeRegistration,
    registrationIndex,
    registrations,
    removeAriaLabel,
    removeParticipantLinkLabel,
    updateAddAdditionalParticipantDisabled,
}) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { pathname } = location;
    const isOnRegistrationPage = pathname.includes("form/registration");
    const { setValues } = useFormikContext();
    const handleRemoveClick = () => {
        // if add another participant link is disabled from limits, enable it
        if (addAdditionalParticipantDisabled) {
            dispatch(
                updateAddAdditionalParticipantDisabled({
                    addAdditionalParticipantDisabled: false,
                }),
            );
        }
        if (isOnRegistrationPage && currentRegistration === registrationIndex) {
            dispatch(setAppShowRemainingForm(false));

            // need to set values in the current formik form with the correct saved registration
            const newIndex = registrationIndex - 1;
            const registrationToReplaceFormValues = registrations[newIndex];
            setValues(registrationToReplaceFormValues);
            setTimeout(() => {
                dispatch(setAppShowRemainingForm(true));
            }, 50);
        }
        dispatch(removeRegistration(registrationIndex));
    };
    return (
        <TextButton handleClick={handleRemoveClick} ariaLabel={removeAriaLabel}>
            <strong>{removeParticipantLinkLabel}</strong>
        </TextButton>
    );
};

ParticipantSummaryRemoveButton.propTypes = {
    addAdditionalParticipantDisabled: PropTypes.bool.isRequired,
    currentRegistration: PropTypes.number.isRequired,
    removeRegistration: PropTypes.func.isRequired,
    registrations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    registrationIndex: PropTypes.number.isRequired,
    removeAriaLabel: PropTypes.string.isRequired,
    removeParticipantLinkLabel: PropTypes.string.isRequired,
    updateAddAdditionalParticipantDisabled: PropTypes.func.isRequired,
};

export default ParticipantSummaryRemoveButton;
